import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Flow, L1r2, L1r3, Nav, Scroll, Single, Swiper } from './components';
var ImageAd = function ImageAd(props) {
  switch (props.mode) {
    case 'swiper':
      return _jsx(Swiper, Object.assign({}, props, {
        pagePadding: props.swiperPagePadding
      }));
    case 'scroll':
      return _jsx(Scroll, Object.assign({}, props, {
        pagePadding: props.scrollPagePadding,
        imageSpacing: props.scrollImageSpacing
      }));
    case 'single':
      return _jsx(Single, Object.assign({}, props, {
        pagePadding: props.singlePagePadding,
        imageSpacing: props.singleImageSpacing
      }));
    case 'flow':
      return _jsx(Flow, Object.assign({}, props, {
        pagePadding: props.flowPagePadding,
        imageSpacing: props.flowImageSpacing
      }));
    case 'l1r2':
      return _jsx(L1r2, Object.assign({}, props, {
        pagePadding: props.l1r2PagePadding,
        imageSpacing: props.l1r2ImageSpacing
      }));
    case 'l1r3':
      return _jsx(L1r3, Object.assign({}, props, {
        pagePadding: props.l1r3PagePadding,
        imageSpacing: props.l1r3ImageSpacing
      }));
    case 'custom':
      return _jsx(_Fragment, {});
    case 'picNav':
      return _jsx(Nav, Object.assign({}, props, {
        pagePadding: props.picNavPagePadding,
        imageSpacing: props.picNavImageSpacing
      }));
    case 'textNav':
      return _jsx(Nav, Object.assign({}, props, {
        pagePadding: props.textNavPagePadding,
        imageSpacing: props.textNavImageSpacing
      }));
    default:
      return _jsx(_Fragment, {});
  }
};
export default ImageAd;